import React from "react";
import { Typography, IconButton, Box, Grid, styled } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const HeaderBox = styled(Box)(({ theme }) => ({
  height: "48px",
  width: "100%",
  alignItems: "center",
  display: "flex",
  paddingLeft: theme.spacing(4),
}));

interface PanelHeaderProps {
  header: string;
  className?: string;
  disabled?: boolean;
  buttonClassName?: string;
  onBack?(): void;
}

export default function PanelHeader({
  className,
  header,
  onBack,
  disabled,
  buttonClassName,
}: PanelHeaderProps) {
  return (
    <>
      <HeaderBox sx={{ py: 0, pr: 0 }} className={className}>
        <Grid container sx={{
          alignItems: "center"
        }}>
          <Grid>
            {onBack && (
              <IconButton
                disabled={disabled}
                onClick={onBack}
                aria-label="back"
                color="inherit"
                className={buttonClassName}
                size="large">
                <ArrowBackIcon />
              </IconButton>
            )}
          </Grid>
          <Grid>
            <Typography variant="h6" component="span" id="panel-header">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </HeaderBox>
    </>
  );
}

export const StyledPanelHeader = styled(PanelHeader)(({ theme }) => ({
  color: theme.palette.background.paper,
  backgroundColor: theme.palette.primary.main,
}));
